jQuery(function ($) {

	//loding.jsでの画像読み込みが遅れる対策
	setTimeout(function () {


		// トップページ - メインビジュアル
		$('.js-slick-main').slick({
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 1000,
			pauseOnHover: true,
			infinite: true,
			lazyLoad: 'progressive',
			dots: true,
			arrows: true,
			prevArrow: '<span class="slide-arrow prev-arrow"><span class="icomoon"></span></span>',
			nextArrow: '<span class="slide-arrow next-arrow"><span class="icomoon"></span></span>',
			slidesToShow: 1,
			centerMode: true,
			slidesToScroll: 1,

			// レスポンシブ設定
			responsive: [{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					centerMode: false,
				}
			}]
		});

	}, 1);


});
